export default function TrustBar() {
  const badges = [
    'Fully Insured to £5M',
    '18+ Years Experience',
    '5-Star Google Rated'
  ];

  return (
    <section className="bg-[#1a1916] py-6 border-y border-[#c9a84c]/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12">
          {badges.map((badge, index) => (
            <div key={index} className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-[#c9a84c] text-xl" aria-hidden="true"></i>
              <span className="text-[#d4d4ce] text-sm font-medium whitespace-nowrap">{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}